<template>
    <div style="text-align: center;">
        <img src="https://cdn.restchip.com/assets/img/chipanim.gif" alt="chip" />
    </div>
</template>